import { useEffect } from 'react'

export default function useEscapeKey(active, callback) {
    useEffect(() => {
        if (!active) return
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') callback()
        }
        document.addEventListener('keydown', handleKeyDown)
        return () => document.removeEventListener('keydown', handleKeyDown)
    }, [active, callback])
}
